<lib-version-update></lib-version-update>
<lib-maintenance></lib-maintenance>
<lib-offline></lib-offline>
<app-loader
  [loadingState]="sessionLoadingState$ | async"
  [helperText]="sessionLoadingText$ | async"
  [top]="0"
  [screenWidth]="true"
></app-loader>
@if ((sessionLoadingState$ | async) == 'loaded') {
  <div class="flex flex-row h-full bg-gray-100 text-gray-800 bg-grey-light-concrete">
    <div
      class="fixed top-10 max-lg:items-center justify-center z-[9999] flex flex-col items-start w-full lg:w-fit mx-auto lg:left-60"
    >
      @if ((collapsedAlertsCount$ | async) > 0) {
        <div
          class="ripple-warning-animation flex items-center bg-white border rounded-full p-2 cursor-pointer mb-2 -mt-6 gap-1"
          (click)="expandAllAlerts()"
          [ngClass]="{
            'border-bright-orange ripple-warning-animation': (limitedAccessAllowed$ | async),
            'border-bright-crimson ripple-error-animation': !(limitedAccessAllowed$ | async),
          }"
          tooltip="Show {{ 'System Alert' | pluralise: (collapsedAlertsCount$ | async) }}"
        >
          <ion-icon
            name="warning"
            class="size-6 -mt-0.5"
            [ngClass]="{
              'text-bright-orange': (limitedAccessAllowed$ | async),
              'text-bright-crimson': !(limitedAccessAllowed$ | async),
            }"
          ></ion-icon>
          @if ((collapsedAlertsCount$ | async) > 0) {
            <span class="font-semibold">{{ collapsedAlertsCount$ | async }}</span>
          }
        </div>
      }
      <div
        class="flex flex-col gap-10 justify-center min-w-60 *:mx-auto *:max-w-128 max-sm:max-w-[99dvw] fixed self-center lg:left-1/2 top-1/3 lg:-ml-56 -mt-36 mx-6"
      >
        @if (alertsVisibility.email.active && !alertsVisibility.email.hidden) {
          <div
            class="ripple-warning-animation border bg-white text-black flex items-start transition-all duration-300 ease-in-out mb-0 p-5 rounded-2xl w-full border-bright-orange"
            id="email-confirmation-banner"
          >
            <div class="flex items-start justify-center">
              <ion-icon name="warning" class="text-bright-orange size-12"></ion-icon>
            </div>
            <div class="-mb-1 ml-4">
              <p class="font-bold text-lg">Email Confirmation Required.</p>
              <p class="text-sm">
                Your user account is unverified and certain features will be limited. To verify, click on the link
                emailed to
                <strong class="font-medium">{{ (session$ | async)?.pending_email }}</strong
                >.
              </p>
              <div class="flex gap-2 mt-2 justify-end">
                <button class="btn-default" (click)="collapseAlert('email')">Not Now</button>
                <button
                  [disabled]="(confirmEmailLoadingState$ | async) == 'loading'"
                  class="btn-primary flex items-center justify-center min-w-[145px]"
                  (click)="resendEmailConfirmation()"
                >
                  <app-loader
                    [loadingState]="confirmEmailLoadingState$ | async"
                    [inline]="true"
                    [size]="16"
                  ></app-loader>
                  @if ((confirmEmailLoadingState$ | async) != 'loading') {
                    <span>Resend Confirmation</span>
                  }
                </button>
              </div>
            </div>
          </div>
        }
        @if (alertsVisibility.mfa.active && !alertsVisibility.mfa.hidden) {
          <div
            class="ripple-error-animation border border-bright-crimson bg-white flex items-start transition-all duration-300 ease-in-out mb-0 p-5 rounded-2xl w-full mx-auto"
            id="mfa-enforced-banner"
          >
            <ion-icon name="warning" class="text-bright-crimson size-12 m-2 ml-0"></ion-icon>
            <div class="-mb-1 ml-2 w-full">
              <p class="font-bold text-lg">Multi-Factor Authentication Required.</p>
              <p class="text-sm">
                Please setup MFA in your profile settings to gain full access to all system features.
              </p>
              <div class="flex gap-2 justify-end mt-2">
                <button class="btn-default" (click)="collapseAlert('mfa')">Not Now</button>
                <button
                  id="mfa-enforced-banner-setup-btn"
                  [routerLink]="['/settings/profile']"
                  (click)="collapseAlert('mfa')"
                  class="btn-primary"
                >
                  Set Up
                </button>
              </div>
            </div>
          </div>
        }
        @if (isConfirmPartnerDetailsRequired) {
          <div
            class="ripple-primary-animation border border-primary bg-gradient-to-br from-turquoise-dark/20 to-turquoise-bright flex items-stretch transition-all duration-300 ease-in-out mb-0 rounded-2xl w-full mx-auto overflow-hidden backdrop-blur-md"
            id="confirm-partner-details-banner"
          >
            <div class="w-1/3 h-max">
              <object type="image/svg+xml" data="../assets/checklist_reminder_animated.svg" height="350px"></object>
            </div>
            <div class="-mb-1 ml-2 w-2/3 bg-white p-8 flex flex-col justify-between shadow-lg">
              <h1 class="font-bold text-xl leading-tight mb-4 text-pretty">
                Please take a moment to review your contact details
              </h1>
              <p class="text-sm py-5 font-normal">
                Confirm your partner contacts and their roles so that critical updates and communications reach the
                right people.
              </p>
              <div class="flex gap-2 justify-end mt-6">
                <button
                  id="confirm-partner-details-button"
                  [routerLink]="['/settings/your-partner-details']"
                  (click)="collapseAlertConfirmPartnerDetails = true; isConfirmPartnerDetailsRequired = false"
                  class="btn-primary btn-lg"
                >
                  Review Contacts
                </button>
              </div>
            </div>
          </div>
        }
        @if (alertsVisibility.agreement.active && !alertsVisibility.agreement.hidden) {
          <div
            id="agreement-banner"
            class="ripple-warning-animation border bg-white text-black flex items-start transition-all duration-300 ease-in-out mb-0 p-5 rounded-2xl w-full mx-auto"
            [ngClass]="{
              'border-bright-orange ripple-warning-animation': (limitedAccessAllowed$ | async),
              'border-bright-crimson ripple-error-animation': !(limitedAccessAllowed$ | async),
            }"
          >
            @if (!(limitedAccessAllowed$ | async)) {
              <ion-icon name="warning" class="text-bright-crimson size-12 ml-0"></ion-icon>
              <div class="-mb-1 ml-3 w-full">
                <p class="font-bold text-lg">Signed Agreement Required.</p>
                <p class="text-sm">
                  You have not signed the latest agreement. <br />
                  Please sign it to gain full access to all system features.
                </p>
                <div class="flex gap-2 justify-end mt-2">
                  <button
                    (click)="presentSendAgreementForSignaturesModal()"
                    class="btn-primary"
                    id="send-agreement-for-signatures-modal-button"
                  >
                    {{ (session$ | async)?.groups[0]?.groups_agreement?.external_id ? 'Resend' : 'Send' }} Agreement
                  </button>
                </div>
              </div>
            } @else {
              <div class="flex items-start justify-center">
                <ion-icon name="warning" class="text-bright-orange size-12"></ion-icon>
              </div>
              <div class="-mb-1 ml-3 w-full">
                <p class="font-bold text-lg">Don't lose access.</p>
                <p class="text-sm">
                  Just <span class="font-semibold">{{ 'day' | pluralise: (limitedAccessDaysLeft$ | async) }} left</span>
                  for you to sign your partner agreement.
                </p>
                <div class="flex gap-2 mt-2 justify-end">
                  <button class="btn-default" (click)="collapseAlert('agreement')">Not Now</button>
                  <button (click)="presentSendAgreementForSignaturesModal()" class="btn-primary">
                    {{ (session$ | async)?.groups[0]?.groups_agreement?.external_id ? 'Resend' : 'Send' }} Agreement
                  </button>
                </div>
              </div>
            }
          </div>
        }
        @if ((totalAlertsCount$ | async) > 1) {
          <div>
            <button class="btn-default bg-grey-blue text-white shadow-lg" (click)="collapseAllAlerts()">
              Close All
            </button>
          </div>
        }
      </div>
    </div>
    <app-side-nav style="view-transition-name: none"></app-side-nav>
    <main
      class="main flex flex-col flex-grow h-full overflow-auto transition-all duration-150 ease-in"
      [style.view-transition-name]="sectionTransitionName$ | async"
    >
      <div class="main-content h-full flex flex-col flex-grow">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
}
